<template>
  <div>
    <v-container>
      <v-row>
        <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
          <emp-lookup
            :class-padding="classPadding"
            v-model="selectedEmp"
            label="Employee Code"
            title="Employee"
            :code-value="true"
            :off-remarks="true"
          ></emp-lookup>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="8" :class="classPadding">
          <v-text-field
            label="Name"
            :value="selectedEmp.desc"
            :class="classPadding"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col xs="12" sm="12" md="12">
          <v-btn
            outlined
            @click.stop="exportReport"
            :loading="loading"
            :class="classPadding"
            >Export</v-btn
          >
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
const API_ENDPOINT = "/api/reports";
const EmpLookup = () =>
  import("../../maintenance/employee-masterfile/personal-info/Lookup");
export default {
  data: () => ({
    classPadding: "my-0 py-0",
    selectedEmp: {},
    loading: false,
  }),
  components: {
    EmpLookup,
  },
  methods: {
    exportReport() {
      this.loading = true;
      var url = `${API_ENDPOINT}/fsea`;
      var param = {
        EmpCode: this.selectedEmp.code,
      };
      this.$axios
        .post(url, param)
        .then((response) => {
          var nameOfTheCsv = "FieldSupportStaffEmploymentAgreement.docx";
          this.$axios
            .get(
              `/Files/WordDocuments/contracts/FieldSupportStaffEmploymentAgreement.docx`,
              {
                responseType: "blob",
              }
            )
            .then((response) => {
              const downloadUrl = window.URL.createObjectURL(
                new Blob([response.data])
              );
              const link = document.createElement("a");
              link.href = downloadUrl;
              link.setAttribute("download", nameOfTheCsv);
              document.body.appendChild(link);
              link.click();
              link.remove();
            })
            .catch((err) => console.log(err));
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
